export interface MsClarityAdapterRegisterConfig {
	/** Microsoft Clarity tracking ID */
	trackingId: string;
}

/**
 * Microsoft Clarity analytics adapter
 * @author filipditrich <ditrich@nfctron.com>
 * @export
 */
export class MsClarityAdapter {
	private allowTracking: boolean;
	private msClarityIds: string[] = [];

	get clarity(): MsClarity | undefined {
		if (typeof window === 'undefined') return undefined;
		return (window as any)?.clarity as MsClarity | undefined;
	}

	constructor(allowTracking: boolean = false) {
		this.allowTracking = allowTracking;
	}

	/**
	 * Registers Microsoft Clarity tracking ID
	 * @param trackingId Microsoft Clarity tracking ID
	 */
	public register = ({ trackingId }: MsClarityAdapterRegisterConfig) => {
		/** ignore when tracking is disallowed */
		if (!this.allowTracking) return;
		/** ignore re-registering the same trackingId */
		if (this.msClarityIds.includes(trackingId)) return;
		/** construct the script */
		console.debug('🧚🏻 [MsClarityAdapter] register(%s) called', trackingId);
		/* eslint-disable */
		// @ts-ignore
		!(function (c, l, a: any, r: any, i: any, t: any, y: any) {
			// @ts-ignore
			c[a] =
				c[a] ||
				function () {
					((c[a] as any).q = (c[a] as any).q || []).push(arguments);
				};
			t = l.createElement(r);
			t.async = 1;
			t.src = 'https://www.clarity.ms/tag/' + i;
			y = l.getElementsByTagName(r)[0];
			y.parentNode.insertBefore(t, y);
		})(window, document, 'clarity', 'script', trackingId);

		/** call the method to register the trackingId */
		this.msClarityIds.push(trackingId);
	};

	/**
	 * Updates the tracking consent
	 * @param allowTracking Tracking consent
	 */
	public updateConsent(allowTracking: boolean) {
		this.allowTracking = allowTracking;
		if (allowTracking) this.clarity?.('consent', true);
		else this.clarity?.('consent', false);
	}
}

/**
 * Microsoft Clarity `clarity` object interface
 */
interface MsClarity {
	(event: 'consent', enable?: boolean): void;
}
